import { TextDirection } from '@strings';

export enum HAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  LEADING = 'leading',
  TRAILING = 'trailing'
}

/**
 * Resolves LEADING and TRAILING alignments to LEFT or RIGHT based on the text direction.
 */
export function horizontalAlignmentForTextDirection(
  alignment: HAlignment,
  textDirection: TextDirection
): HAlignment {
  switch (alignment) {
    case HAlignment.LEADING:
      return textDirection === TextDirection.LTR ? HAlignment.LEFT : HAlignment.RIGHT;
    case HAlignment.TRAILING:
      return textDirection === TextDirection.LTR ? HAlignment.RIGHT : HAlignment.LEFT;
    default:
      return alignment;
  }
}

export enum VAlignment {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
  BASELINE = 'baseline'
}

export interface Alignment {
  h?: HAlignment;
  v?: VAlignment;
  textDirection?: TextDirection;
}
